export const SIMILARITY_STATUS = {
  NOT_STARTED : 'not_started',
  PROCESSING  : 'processing',
  COMPLETE    : 'complete',
  ERROR       : 'error',
  HIDDEN      : 'hidden'
};

export const SMART_PROVIDERS = {
  TURNITIN : 'turnitin',
  GOMINING : 'gomining'
};

export const SMART_FEATURES = {
  SIMILARITY : 'similarity',
  AUTO_GRADE : 'auto_grade'
};

export const AUTO_GRADE_STATUS = {
  UNTRAINED            : 'UNTRAINED',
  AI_TRAINING          : 'PROCESSING',
  UPDATED              : 'READY',
  OUTDATED             : 'OUTDATED',
  INSUFFICIENT_CONTENT : 'INSUFFICIENT_CONTENT',
  LIMITED_CORRECTION   : 'LIMITED_CORRECTION',
  REVIEW_CONTENT       : 'REVIEW',
  UNEXPECTED_ERROR     : 'UNEXPECTED_ERROR'
};

export const GLOBAL_AUTO_GRADE_STATUS = [
  AUTO_GRADE_STATUS.AI_TRAINING,
  AUTO_GRADE_STATUS.UNTRAINED,
  AUTO_GRADE_STATUS.OUTDATED
];

export const mapAutoGradeStatusChip = () => ({
  [AUTO_GRADE_STATUS.AI_TRAINING]: {
    tooltipMessage : window.$nuxt.$t('content.cardTopic.autoGrade.aiTrainingTooltip'),
    text           : window.$nuxt.$t('content.cardTopic.autoGrade.aiTraining'),
    icon           : 'mdi-creation',
    type           : 'ai'
  },
  [AUTO_GRADE_STATUS.UNTRAINED]: {
    tooltipMessage : window.$nuxt.$t('content.cardTopic.autoGrade.untrainedTooltip'),
    text           : window.$nuxt.$t('content.cardTopic.autoGrade.untrained'),
    icon           : 'mdi-progress-upload',
    type           : 'pending'
  },
  [AUTO_GRADE_STATUS.UPDATED]  : null,
  [AUTO_GRADE_STATUS.OUTDATED] : {
    tooltipMessage : window.$nuxt.$t('content.cardTopic.autoGrade.outdatedTooltip'),
    text           : window.$nuxt.$t('content.cardTopic.autoGrade.outdated'),
    icon           : 'mdi-progress-upload',
    type           : 'pending'
  },
  [AUTO_GRADE_STATUS.INSUFFICIENT_CONTENT]: {
    tooltipMessage : window.$nuxt.$t('content.cardTopic.autoGrade.insufficientContent'),
    text           : window.$nuxt.$t('content.cardTopic.autoGrade.insufficientContent'),
    icon           : 'mdi-emoticon-sad-outline',
    type           : 'warning'
  },
  [AUTO_GRADE_STATUS.LIMITED_CORRECTION]: {
    tooltipMessage : window.$nuxt.$t('content.cardTopic.autoGrade.limitedCorrection'),
    text           : window.$nuxt.$t('content.cardTopic.autoGrade.limitedCorrection'),
    icon           : 'mdi-pencil-off',
    type           : 'warning'
  },
  [AUTO_GRADE_STATUS.REVIEW_CONTENT]: {
    tooltipMessage : window.$nuxt.$t('content.cardTopic.autoGrade.reviewContent'),
    text           : window.$nuxt.$t('content.cardTopic.autoGrade.reviewContent'),
    icon           : 'mdi-pencil-circle-outline',
    type           : 'warning'
  },
  [AUTO_GRADE_STATUS.UNEXPECTED_ERROR]: {
    tooltipMessage : window.$nuxt.$t('content.cardTopic.autoGrade.unexpectedError'),
    text           : window.$nuxt.$t('content.cardTopic.autoGrade.unexpectedError'),
    icon           : 'mdi-alert-circle',
    type           : 'error'
  }
});

export const mapAutoGradeStatusTooltip = () => ({
  [AUTO_GRADE_STATUS.AI_TRAINING]: {
    tooltip : `<b>${window.$nuxt.$t('content.cardTopic.autoGrade.aiTraining')}:</b><br>${window.$nuxt.$t('content.cardTopic.autoGrade.aiTrainingTooltip')}`,
    icon    : 'mdi-creation',
    color   : 'var(--v-ai-base)'
  },
  [AUTO_GRADE_STATUS.UNTRAINED]: {
    tooltip : `<b>${window.$nuxt.$t('content.cardTopic.autoGrade.untrained')}:</b><br>${window.$nuxt.$t('content.cardTopic.autoGrade.untrainedTooltip')}`,
    icon    : 'mdi-progress-upload',
    color   : 'var(--color-text)'
  },
  [AUTO_GRADE_STATUS.UPDATED]  : null,
  [AUTO_GRADE_STATUS.OUTDATED] : {
    tooltip : `<b>${window.$nuxt.$t('content.cardTopic.autoGrade.outdated')}:</b><br>${window.$nuxt.$t('content.cardTopic.autoGrade.outdatedTooltip')}`,
    icon    : 'mdi-progress-upload',
    color   : 'var(--color-text)'
  },
  [AUTO_GRADE_STATUS.INSUFFICIENT_CONTENT]: {
    tooltip : window.$nuxt.$t('content.cardTopic.autoGrade.insufficientContent'),
    icon    : 'mdi-emoticon-sad-outline',
    color   : 'var(--v-warning-base)'
  },
  [AUTO_GRADE_STATUS.LIMITED_CORRECTION]: {
    tooltip : window.$nuxt.$t('content.cardTopic.autoGrade.limitedCorrection'),
    icon    : 'mdi-pencil-off',
    color   : 'var(--v-warning-base)'
  },
  [AUTO_GRADE_STATUS.REVIEW_CONTENT]: {
    tooltip : window.$nuxt.$t('content.cardTopic.autoGrade.reviewContent'),
    icon    : 'mdi-pencil-circle-outline',
    color   : 'var(--v-warning-base)'
  },
  [AUTO_GRADE_STATUS.UNEXPECTED_ERROR]: {
    tooltip : window.$nuxt.$t('content.cardTopic.autoGrade.unexpectedError'),
    icon    : 'mdi-alert-circle',
    color   : 'var(--v-error-base)'
  }
});

export const LIGHT_STATUS_COLOR_MAP = {
  'var(--v-ai-base)'      : 'var(--v-ai-lighten5)',
  'var(--color-text)'     : 'var(--v-neutrals-20-base)',
  'var(--v-warning-base)' : 'var(--v-warning-lighten5)',
  'var(--v-error-base)'   : 'var(--v-error-lighten5)'
};

export const getAutoGradeStatus = ({
  tooltipPropName,
  autoGradeResponse,
  autoGradeStatus,
  autoGradeStatusMap,
  getterAutoGradeStatus
}) => {
  if (GLOBAL_AUTO_GRADE_STATUS.includes(getterAutoGradeStatus)) {
    return autoGradeStatusMap[getterAutoGradeStatus];
  }

  if (!autoGradeResponse) {
    return;
  }

  if (autoGradeStatus in autoGradeStatusMap) {
    const statusChip = autoGradeStatusMap[autoGradeStatus];

    if (statusChip === null) {
      return;
    }

    return {
      ...statusChip,
      [tooltipPropName]: autoGradeResponse.obs || statusChip[tooltipPropName]
    };
  }

  return {
    ...autoGradeStatusMap[AUTO_GRADE_STATUS.UNEXPECTED_ERROR],
    [tooltipPropName]: autoGradeResponse?.obs || autoGradeStatusMap[AUTO_GRADE_STATUS.UNEXPECTED_ERROR].tooltipMessage
  };
};

export const getAutoGradeStatusFromContext = (context) => {
  const { autoGrade } = context;

  if (!autoGrade) {
    return null;
  }

  if (autoGrade.isPending) {
    return AUTO_GRADE_STATUS.AI_TRAINING;
  }

  if (!autoGrade.lastSent) {
    return AUTO_GRADE_STATUS.UNTRAINED;
  }

  if (autoGrade.isOutdated) {
    return AUTO_GRADE_STATUS.OUTDATED;
  }

  return AUTO_GRADE_STATUS.UPDATED;
} ;
